import { render, staticRenderFns } from "./verification-code-log.vue?vue&type=template&id=707b7b02&scoped=true&"
import script from "./verification-code-log.vue?vue&type=script&lang=js&"
export * from "./verification-code-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b7b02",
  null
  
)

export default component.exports